
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talentos",
      function () {
        return require("private-next-pages/talentos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talentos"])
      });
    }
  